import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { makeResetCache, fetchApi, notifyResponse, notifyError } from 'gossamer-front-end';
import { AdminInstitutionGroupDeactivateRequest, InstitutionGroupEvent } from 'cb-model';

export interface GroupDeleteEventsButtonProps {
  institutionGroupId: number;
}

export const GroupDeleteEventsButton = (props: GroupDeleteEventsButtonProps): React.JSX.Element => {
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const isProcessing = React.useRef(false);

  const handleDelete = async () => {
    const check = confirm('This deletes all the events from the group. Are you sure? This action cannot be reversed.');
    if (!check) {
      return;
    }
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const resp = await fetchApi('POST', `/main/group-event-delete-all`, {
        institutionGroupId: props.institutionGroupId,
      } as AdminInstitutionGroupDeactivateRequest);
      resetCache(InstitutionGroupEvent.id);
      notifyResponse(resp);
    } catch (e) {
      notifyError(e, 'An error occurred while deleting events from this institution group');
    }
    isProcessing.current = false;
  };

  return (
    <Button type="button" size="sm" variant="danger" onClick={handleDelete}>
      Delete Events
    </Button>
  );
};
